<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-12-04 
-->
<template>
  <div class="viewer-container">
    <iframe :src="viewerSrc" width="100%"></iframe>
  </div>
</template>
<script>
import { decryptUrl } from 'js/crypto'
export default {
  components: {},
  created() {
    if (this.$route.query.file) {
      const decrypted = decryptUrl(this.$route.query.file)
      this.viewerSrc = `${window.location.protocol}//static-cdn.vcbeat.top/pdf/web/viewer.html?file=${decrypted}`
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('keydown', (event) => {
        const isCtrl = event.ctrlKey || event.metaKey // 适配 Windows/Mac
        const isShift = event.shiftKey
        // 禁止 F12
        if (event.key === 'F12') {
          event.preventDefault()
        }
        // 禁止 Ctrl+S/Command+S
        else if (isCtrl && event.key === 's') {
          event.preventDefault()
        }
        // 禁止 Ctrl+Shift+I/Command+Shift+I
        else if (isCtrl && isShift && event.key === 'i') {
          event.preventDefault()
        }
        // 禁止 Ctrl+U/Command+U（查看源代码）
        else if (isCtrl && event.key === 'u') {
          event.preventDefault()
        }
      })
      window.addEventListener('contextmenu', (event) => {
        event.preventDefault()
      })
    })
  },
  data() {
    return {
      viewerSrc: '',
    }
  },
  computed: {},
  methods: {},
}
</script>
<style lang='stylus' scoped>
.viewer-container
  iframe
    width 100vw
    height 100vh
    border 0
    display block
</style>